import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_element_sequence_RowClass } from "../../../dbschema";

export class BotCfElementSequenceContainerModel extends BaseContainerModel{
  alg_bot_cf_element_sequence: alg_bot_cf_element_sequence_RowClass = new alg_bot_cf_element_sequence_RowClass();
}
